import { CategoryData } from '../../../../types/types';

export const objets: CategoryData = {
    'Sɛbɛn (Livre)': {
        translation: 'Livre',
        translationEn: 'Book',
        illustration: '📖',
        example: 'Ne bee sɛbɛn ni min ye. (J\'ai lu le livre.)',
        exampleEn: 'Ne bee sɛbɛn ni min ye. (I read the book.)'
    },
     'Samara (Chaussure)': {
        translation: 'Chaussure',
        translationEn: 'Shoe',
        illustration: '📖',
        audio: 'Ba-samara',
        example: '',
        exampleEn: ''
    },
    'Dɔgɔkɛ (Table)': {
        translation: 'Table',
        translationEn: 'Table',
        illustration: '🪑',
        example: 'Dɔgɔkɛ in ka san ka dɔrɔn. (Cette table est solide.)',
        exampleEn: 'Dɔgɔkɛ in ka san ka dɔrɔn. (This table is sturdy.)'
    },
    'Sɛbɛnkɛlan (Crayon)': {
        translation: 'Crayon',
        translationEn: 'Pencil',
        illustration: '✒️',
        example: 'A tagara sɛbɛnkɛlan koolo. (Il a pris un crayon.)',
        exampleEn: 'A tagara sɛbɛnkɛlan koolo. (He took a pencil.)'
    },
    'Bankɛ (Maison)': {
        translation: 'Maison',
        translationEn: 'House',
        illustration: '🏠',
        example: 'An ka bankɛ tilana ye. (Notre maison est belle.)',
        exampleEn: 'An ka bankɛ tilana ye. (Our house is beautiful.)'
    },
    'Sarikɛla (Sac)': {
        translation: 'Sac',
        translationEn: 'Bag',
        illustration: '👜',
        example: 'N sarikɛla bɛ dɔnniya la. (Mon sac est sur la chaise.)',
        exampleEn: 'N sarikɛla bɛ dɔnniya la. (My bag is on the chair.)'
    },

    'Dɔnniya (Chaise)': {
        translation: 'Chaise',
        translationEn: 'Chair',
        illustration: '🪑',
        example: 'Ne bɛ dɔnniya kan. (Je suis assis sur la chaise.)',
        exampleEn: 'Ne bɛ dɔnniya kan. (I am sitting on the chair.)'
    },
    'Filanw (Corde)': {
        translation: 'Corde',
        translationEn: 'Rope',
        illustration: '🧶',
        example: 'Filanw bɛ bankɛ dɔrɔn. (La corde est près de la maison.)',
        exampleEn: 'Filanw bɛ bankɛ dɔrɔn. (The rope is near the house.)'
    },
    'Sɛribɛ (Bouteille)': {
        translation: 'Bouteille',
        translationEn: 'Bottle',
        illustration: '🍾',
        example: 'Ne sɛribɛ bɛ dɔgɔkɛ kan. (Ma bouteille est sur la table.)',
        exampleEn: 'Ne sɛribɛ bɛ dɔgɔkɛ kan. (My bottle is on the table.)'
    },
    'Sɔgɔma (Balai)': {
        translation: 'Balai',
        translationEn: 'Broom',
        illustration: '🧹',
        audio: 'Ba-sogoma',
        example: 'N bɛ sɔgɔma min. (Je balaie avec le balai.)',
        exampleEn: 'N bɛ sɔgɔma min. (I sweep with the broom.)'
    },

     'Gwakɛminan (Ustensile)': {
        translation: 'ustensile',
        translationEn: 'utensil',
        illustration: '',
        audio: 'Ba-gwakeminan',

    },
    'Bankɛdalaw (Toit)': {
        translation: 'Toit',
        translationEn: 'Roof',
        illustration: '🏠',
        example: 'Bankɛdalaw bɛ kɛ dɛmɛ ye. (Le toit est fait de tôle.)',
        exampleEn: 'Bankɛdalaw bɛ kɛ dɛmɛ ye. (The roof is made of sheet metal.)'
    },
    'Furaba (Fenêtre)': {
        translation: 'Fenêtre',
        translationEn: 'Window',
        illustration: '🪟',
        example: 'Furaba bɛ tile kunbɛn. (La fenêtre est ouverte.)',
        exampleEn: 'Furaba bɛ tile kunbɛn. (The window is open.)'
    },
    'Niɲɛ (Porte)': {
        translation: 'Porte',
        translationEn: 'Door',
        illustration: '🚪',
        example: 'N niɲɛ bɛ lase ye. (Ma porte est fermée.)',
        exampleEn: 'N niɲɛ bɛ lase ye. (My door is closed.)'
    },
    'Mugu (Cuillère)': {
        translation: 'Cuillère',
        translationEn: 'Spoon',
        illustration: '🥄',
        example: 'Ne ka mugu bɛ dɔgɔkɛ kan. (Ma cuillère est sur la table.)',
        exampleEn: 'Ne ka mugu bɛ dɔgɔkɛ kan. (My spoon is on the table.)'
    },

    'Kudu (louche)': {
        translation: 'louche',
        translationEn: 'ladle',
        illustration: '🥄',
        audio: 'Ba-kudu',
    },

      'Kudu sɔgɔsɔgɔnin (écumoire)': {
        translation: 'écumoire',
        translationEn: 'skimmer',
        illustration: '🥄',
        audio: 'Ba-kudu sogosogonin',
    },




     'Sigilan (chaise)': {
        translation: 'chaise',
        translationEn: 'chair',
        illustration: '🪑',
        audio: 'Ba-sigilan',

    },

      'Sigilan magaman(fauteuil)': {
        translation: 'fauteuil',
        translationEn: 'armchair',
        illustration: '🪑',
        audio: 'Ba-sigilan magaman',

    },

      'Tasa(plat)': {
        translation: 'plat',
        translationEn: 'dish',
        illustration: '🍽️',
        audio: 'Ba-tasa',

    },

     'Dalan(lit)': {
        translation: 'lit',
        translationEn: 'bed',
        illustration: '🛏️',
        audio: 'Ba-dalan',

    },




    'Suma (Assiette)': {
        translation: 'Assiette',
        translationEn: 'Plate',
        illustration: '🍽️',
        example: 'Suma in ka siran ye. (Cette assiette est propre.)',
        exampleEn: 'Suma in ka siran ye. (This plate is clean.)'
    },

      'Dibi (four)': {
        translation: 'four',
        translationEn: 'oven',
        illustration: '�',
        audio: 'Ba-dibi',

    },
    'Jabaranin (Télévision)': {
        translation: 'Télévision',
        translationEn: 'Television',
        illustration: '�',
        audio: 'Ba-jabaranin',

    },

    'Minanbilaminan (Armoire)': {
        translation: 'Armoire',
        translationEn: 'Wardrobe',
        illustration: '',
        audio: 'Ba-minanbilaminan',

    },

     'Ŋamandonyɔrɔ (Armoire)': {
        translation: 'Armoire',
        translationEn: 'Wardrobe',
        illustration: '',

    },


     'Tango (Poele à frire)': {
        translation: 'Poele à frire',
        translationEn: 'Frying pan',
        illustration: '',
        audio: 'Ba-Tango',

    },
    'Telefɔni (Téléphone)': {
        translation: 'Téléphone',
        translationEn: 'Phone',
        illustration: '📱',
        example: 'N ka telefɔni bɛ joona. (Mon téléphone sonne.)',
        exampleEn: 'N ka telefɔni bɛ joona. (My phone is ringing.)'
    },
    'Sɔrɔbana (Voiture)': {
        translation: 'Voiture',
        translationEn: 'Car',
        illustration: '🚗',
        example: 'An ka sɔrɔbana bɛ senkɔrɔ la. (Notre voiture est dans la rue.)',
        exampleEn: 'An ka sɔrɔbana bɛ senkɔrɔ la. (Our car is in the street.)'
    },

    'Gɛlɛnkɛ (Couteau)': {
        translation: 'Couteau',
        translationEn: 'Knife',
        illustration: '🔪',
        example: 'N ka gɛlɛnkɛ bɛ suma kɔnɔ. (Mon couteau est dans l\'assiette.)',
        exampleEn: 'N ka gɛlɛnkɛ bɛ suma kɔnɔ. (My knife is in the plate.)'
    },

     'Gabugu (Cuisine)': {
        translation: 'Cuisine',
        translationEn: 'Kitchen',
        illustration: '🔪',
        audio: 'Ba-gabugu',
        example: '',
        exampleEn: ''
    },
      'Tasuma (Feu)': {
        translation: 'Feu',
        translationEn: 'Fire',
        illustration: '',
        audio: 'Ba-tasuma',
        example: 'Sisan i be tasuma mana ka soro ka tigɛdegɛ nin nin don a ra. (Maintenant tu allumes le feu et tu mets la pâte d\'arachides )',
        exampleEn: 'Sisan i be tasuma mana ka soro ka tigɛdegɛ nin nin don a ra. (Now you light the fire and put in the peanut paste)'
    },

      'Daga (Marmite)': {
        translation: 'Marmite',
        translationEn: 'Cooking pot',
        illustration: '',
        audio: 'Ba-daga',
        example: '',
        exampleEn: ''
    }
};

export default objets;
export {};
